import { render } from "./EmailOptIn.vue?vue&type=template&id=bd03e68a"
import script from "./EmailOptIn.vue?vue&type=script&lang=js"
export * from "./EmailOptIn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/quiz/routes/EmailOptIn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bd03e68a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bd03e68a', __exports__)) {
    api.reload('bd03e68a', __exports__)
  }
  
  module.hot.accept("./EmailOptIn.vue?vue&type=template&id=bd03e68a", () => {
    api.rerender('bd03e68a', render)
  })

}


export default __exports__